// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__3iODy","ItemBody":"Item_ItemBody__16ODI"};